/**
 * Copyright (c) 2025 eBUCIS, LLC. All rights reserved.
 *
 * PatentPendingBadge - small, graceful "Patent Pending" legal notice.
 *
 * Rendered in the auth shell (login/register) and the main app shell so the
 * platform's pending-patent status is visible without being intrusive. Text is
 * sourced from the central branding config.
 *
 * This software is proprietary and confidential. Unauthorized copying,
 * distribution, or modification is strictly prohibited.
 */

import PropTypes from 'prop-types'
import { ShieldCheck } from 'lucide-react'
import { branding } from '../config/branding'

const PatentPendingBadge = ({ className = '' }) => {
  return (
    <span
      title="This technology is the subject of one or more pending patent applications."
      className={`inline-flex items-center gap-1.5 rounded-full border border-primary-200 dark:border-primary-800 bg-primary-50 dark:bg-primary-900/20 px-2.5 py-1 text-[11px] font-semibold uppercase tracking-[0.08em] text-primary-700 dark:text-primary-300 ${className}`}
    >
      <ShieldCheck className="w-3.5 h-3.5" aria-hidden="true" />
      {branding.patentStatus}
    </span>
  )
}

PatentPendingBadge.propTypes = {
  className: PropTypes.string
}

export default PatentPendingBadge
